import { useClientSideTableFilter } from "~components/DataTable/hooks/useClientSideTableFilter.ts";
import type { ClientSideTableSearchField } from "~components/DataTable/types/clientSideTableSearchField.ts";
import { filterByTableField } from "~components/DataTable/utils/filterByTableField.ts";
import { SeasonTableColumns } from "~pages/Seasons/SeasonListPage/enums/seasonTableColumns.ts";
import { SeasonTableFilterTypes } from "~pages/Seasons/SeasonListPage/enums/seasonTableFilterTypes.ts";
import type { SeasonTransformed } from "~types/seasonTransformed.ts";

const seasonSearchFields: Array<ClientSideTableSearchField<SeasonTransformed>> = [SeasonTableColumns.NameLocal];

const seasonFilterFunctions = {
  [SeasonTableFilterTypes.AgeGroup]: filterByTableField<SeasonTransformed>(SeasonTableColumns.AgeGroup),
  [SeasonTableFilterTypes.Gender]: filterByTableField<SeasonTransformed>(SeasonTableColumns.Gender),
  [SeasonTableFilterTypes.Status]: filterByTableField<SeasonTransformed>(SeasonTableColumns.Status),
  [SeasonTableFilterTypes.Standard]: filterByTableField<SeasonTransformed>(SeasonTableColumns.Standard),
  [SeasonTableFilterTypes.CompetitionName]: filterByTableField<SeasonTransformed>(SeasonTableColumns.CompetitionId),
};

type Props = {
  seasons: SeasonTransformed[];
  currentFilter: Record<string, unknown>;
  searchText: string;
};

export const useFilteredSeasons = ({ seasons, currentFilter, searchText }: Props): SeasonTransformed[] => {
  return useClientSideTableFilter({
    data: seasons,
    currentFilter,
    filterFunctions: seasonFilterFunctions,
    searchText,
    searchFields: seasonSearchFields,
  }).filteredData;
};
